import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-crm-banche',
  templateUrl: './crm-banche.component.html',
  styleUrls: ['./crm-banche.component.css']
})
export class CrmBancheComponent implements OnInit {

  @Input() titolo: string;
  service = 'crmBancheGrid';

  constructor() { }

  ngOnInit() {
  }

}
